export default "__VITE_ASSET__C_iSlXDp__"